// Copyright (c) 2016 Deere & Company

import actions from '../../../action-list';

export const resetConfirmationModal = () => ({
    type: actions.RESET_CLAIM_MAINTENANCE_PLAN_CONFIRMATION_MODAL
});

export const updateConfirmationModal = options => ({
    data: options,
    type: actions.UPDATE_CLAIM_MAINTENANCE_PLAN_CONFIRMATION_MODAL
});



// WEBPACK FOOTER //
// ./src/claim/marketing/maintenance-plan/action-creators/confirmation-modal.js